module.exports = __webpack_public_path__ + "static/media/sparq3.b36926f7.jpg";